module.exports = __webpack_public_path__ + "img/testimonials-right.1d6d9467.jpg";